<app-multi-lingual *ngIf="!loggedInUser"></app-multi-lingual>
<app-left-menu *ngIf="loggedInUser">
</app-left-menu>


<div id="main-container">


  <app-header *ngIf="loggedInUser" [title]="title"></app-header>
  <div class="content-header"></div>


  <div class="page-content">
    <div class="content-min">
      <div class="row">

        
        <div class="sub-page-title">{{'Contact.FormHeading'|translate}}</div>
        <form [formGroup]="contactUsForm" (ngSubmit)="submitForm(contactUsForm.value, contactUsForm.valid)">
          <div class="row contact-us">
            <div class="col-md-12">

              <div class="error-message display-block">
                <span *ngIf="!contactUsForm.controls['FirstName'].valid && contactUsForm.controls['FirstName'].touched">{{'Contact.FirstNameErrMsg'|translate}} </span>
                <span *ngIf="!contactUsForm.controls['LastName'].valid && contactUsForm.controls['LastName'].touched">{{'Contact.LastNameErrMsg'|translate}} </span>
                <span *ngIf="!contactUsForm.controls['PhoneNo'].valid && contactUsForm.controls['PhoneNo'].touched">{{'Contact.PhoneNoErrMsg'|translate}} </span>
                
                <span *ngIf="!contactUsForm.controls['Email'].valid && contactUsForm.controls['Email'].touched">{{'Contact.EmailErrMsg'|translate}} </span>
              </div>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="{{'Common.FirstName'|translate}} ({{'Common.Required'|translate}})"
                formControlName="FirstName" maxlength="255">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="{{'Common.LastName'|translate}} ({{'Common.Required'|translate}})" formControlName="LastName"
                maxlength="255">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="{{'Common.Title'|translate}}" formControlName="Title">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="{{'Common.Company'|translate}}" formControlName="Company">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control phone_us" placeholder="{{'Common.PhoneNo'|translate}}" formControlName="PhoneNo" maxlength="14" minlength="14">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="{{'Common.Email'|translate}} ({{'Common.Required'|translate}})" formControlName="Email"
                maxlength="255">
            </div>
            <div class="col-md-12">
              <textarea class="form-control"  placeholder="{{'Common.Comments'|translate}}" formControlName="Comments"></textarea>
            </div>
            <div class="col-md-12">
              <button class="btn btn-main" [disabled]="!contactUsForm.valid">{{'Common.Submit'|translate}}</button>
            </div>
            <!-- <div class="col-md-12" style="visibility:hidden;">
             <p>a</p> <p>a</p><p>a</p>
            </div> -->

          </div>
        </form>
      </div>
    </div>
  </div>

</div>